// extracted by mini-css-extract-plugin
export default {"container":"FullPageSpin_container__GWx-9"};